import React from 'react';
import Button from '../../../../../core/form/Button';
import ColumnSeparator from '../../../../../core/layout/ColumnSeparator';
import PropTypes from 'prop-types';

const Actions = {
  BACK: 'BACK',
  ITEM_SHIFT: 'ITEM_SHIFT',
  SHIFT: 'SHIFT',
  SHIFT_DISABLED: 'SHIFT_DISABLED',
  ADD_NEW_ITEM: 'ADD_NEW_ITEM',
  CANCEL: 'CANCEL',
  IMAGE_PROMPT: 'IMAGE_PROMPT',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
};

const UnitItemListActions = (props) => (
  <>
    {props.actions.includes(Actions.IMAGE) && (
      <>
        <Button
          icon="picture"
          label="Generate Images (drafts)"
          disabled={props.submitting}
          onClick={() => props.onAction(Actions.IMAGE)}
        />
        <ColumnSeparator size="xxs" />
      </>
    )}
    {props.actions.includes(Actions.AUDIO) && (
      <>
        <Button
          icon="audio"
          label="Generate Audios (drafts)"
          disabled={props.submitting}
          onClick={() => props.onAction(Actions.AUDIO)}
        />
        <ColumnSeparator size="xxs" />
      </>
    )}
    {props.actions.includes(Actions.BACK) && (
      <>
        <Button
          icon="arrow-left"
          label="Back"
          disabled={props.submitting}
          onClick={() => props.onAction(Actions.BACK)}
        />
        <ColumnSeparator size="xxs" />
      </>
    )}
    {props.actions.includes(Actions.ITEM_SHIFT) && (
      <>
        <Button
          icon="swap"
          label="Items shift"
          disabled={props.submitting}
          onClick={() => props.onAction(Actions.ITEM_SHIFT)}
        />
        <ColumnSeparator size="xxs" />
      </>
    )}
    {props.actions.includes(Actions.ADD_NEW_ITEM) && (
      <>
        <Button
          icon="plus"
          type="primary"
          disabled={props.submitting}
          onClick={() => props.onAction(Actions.ADD_NEW_ITEM)}
          label="Add new item"
        />
        <ColumnSeparator size="xxs" />
      </>
    )}
    {props.actions.includes(Actions.CANCEL) && (
      <>
        <Button
          icon="reload"
          label="Cancel"
          disabled={props.submitting}
          onClick={() => props.onAction(Actions.CANCEL)}
        />
        <ColumnSeparator size="xxs" />
      </>
    )}
    {(props.actions.includes(Actions.SHIFT) || props.actions.includes(Actions.SHIFT_DISABLED)) && (
      <>
        <Button
          icon="swap"
          label="Shift"
          disabled={props.submitting || props.actions.includes(Actions.SHIFT_DISABLED)}
          onClick={() => props.onAction(Actions.SHIFT)}
        />
        <ColumnSeparator size="xxs" />
      </>
    )}
  </>
);

UnitItemListActions.propTypes = {
  onAction: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  actions: PropTypes.arrayOf(
    PropTypes.oneOf([
      Actions.BACK,
      Actions.ADD_NEW_ITEM,
      Actions.CANCEL,
      Actions.ITEM_SHIFT,
      Actions.SHIFT,
      Actions.SHIFT_DISABLED,
    ])
  ),
};

UnitItemListActions.defaultProps = {
  submitting: false,
  actions: [Actions.BACK, Actions.ADD_NEW_ITEM],
};

export default UnitItemListActions;

export { Actions };
